let hotspotTooltip = {};

hotspotTooltip = tippy('.hotspot', {
	trigger:     'click',
	theme:       'hotspot',
	maxWidth:    '360px',
	offset:      [0, 15],
	interactive: true,
	arrow:       false,
	allowHTML:   true,
	content(reference) {
		const id = reference.getAttribute('data-template');
		const template = document.getElementById(id);
		return template.innerHTML
	},
	popperOptions: {
		modifiers: [
			{
				name: 'flip',
				options: {
					fallbackPlacements: ['bottom', 'right', 'top', 'left'],
				},
			}
		],
	},
});